import React from 'react';
import cn from 'classnames';

import Header from '../Header';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import { forgotRoot } from './styles';

function ForgotPassword() {
  return (
    <div
      className={cn(
        forgotRoot,
        'relative flex h-full w-full max-w-full flex-col items-center overflow-auto',
      )}>
      <Header
        LeftNodeRef="@lyearn/components/Header/BrandInfo"
        RightNode={null}
        RightNodeRef={null}
        centered={true}
        headerStyles={{
          solidBackgroundColor: 'rgba(255, 255, 255, 0.96)',
        }}
        headerType="sticky"
        height="8rem"
        leftNodeProps={{
          isHomepage: true,
        }}
        middleNodeAlign="center"
        rightNodeProps={{
          authType: 'LOGIN_SIGNUP',
          primaryBtn: {
            text: 'Login',
          },
          secondaryBtn: {
            text: 'Create Account',
            variant: 'filled',
          },
        }}
      />
      <ForgotPasswordForm />
    </div>
  );
}

export default ForgotPassword;
